module.exports = {
  stylePrefix: 'sm-',

  sectors: [
    {
      name: 'Tło kreacji',
      open: true,
      buildProps: ['background-color', 'background']
    }
  ],

  // Specify the element to use as a container, string (query) or HTMLElement
  // With the empty value, nothing will be rendered
  appendTo: '',

  // Text to show in case no element selected
  textNoElement: 'Select an element before using Style Manager',

  // Hide the property in case it's not stylable for the
  // selected component (each component has 'stylable' property)
  hideNotStylable: true,

  // Highlight changed properties of the selected component
  highlightChanged: true,

  // Highlight computed properties of the selected component
  highlightComputed: false,

  // Show computed properties of the selected component, if this value
  // is set to false, highlightComputed will not take effect
  showComputed: false,

  // Adds the possibility to clear property value from the target style
  clearProperties: 1,

  // Properties not to take in account for computed styles
  avoidComputed: ['width', 'height']
};
